import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { public: true },
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    // Startup lands here → guard sends you to /login when signed out,
    // or straight into the portal when signed in.
    path: '/',
    redirect: '/portal'
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/changelog',
    name: 'changelog',
    component: () => import(/* webpackChunkName: "changelog" */ '../views/ChangelogView.vue')
  },
  {
    path: '/portal',
    name: 'portal',
    component: () => import(/* webpackChunkName: "portal" */ '../views/PortalView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Simple front-end auth gate: every non-public route requires a sign-in flag.
// On startup an unauthenticated visitor is sent to the login page.
const isAuthed = () =>
  window.localStorage.getItem('gm-auth') === '1' ||
  window.sessionStorage.getItem('gm-auth') === '1'

router.beforeEach((to) => {
  const authed = isAuthed()
  if (!to.meta.public && !authed) {
    return { name: 'login', query: to.fullPath === '/' ? {} : { redirect: to.fullPath } }
  }
  if (to.name === 'login' && authed) {
    return { name: 'portal' }
  }
  return true
})

export default router
